import axios from "@/axios"; 

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    async deleteData(id) {
      try {
        const response = await axios.delete(API_URL + `/api-put-onu-olt-data-port/${id}/`);
        return response.data;
      } catch (error) {
        console.error("Error retrieving user:", error);
        throw error; 
      }
    },
  };
